import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Helpers from '../../../../common/helpers';

class HeaderProfileSection extends Component {
  render() {
    const { profile } = this.props;
    const { t } = this.context;

    return (
      <div className="header-container__left-part__profile">
        <p className="text">
          {t('COMMON.WELCOME')}, {profile && profile.first_name} {profile && profile.last_name}
        </p>
        <p className="text">
          {t('HEADER.PARTNER_ID')}: {profile && profile.user_id}
        </p>
        <p className="text">
          {t('HEADER.PARTNER_PLAN')}: {t(Helpers.getUserType(profile))}
        </p>
      </div>
    );
  }
}

HeaderProfileSection.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default HeaderProfileSection;



// WEBPACK FOOTER //
// ./src/app/main/layout/components/header-profile-section.js